import { Box, Typography } from "@mui/material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { useEffect, useState } from "react";
import axios from "axios";


const getIcon = (module: string) => {
  switch (module?.toLowerCase()) {
    case "purchase":
      return {
        icon: <Inventory2OutlinedIcon fontSize="small" />,
        bg: "#E6F4EA",
        color: "#2E7D32",
      };
    case "sales":
      return {
        icon: <LocalShippingOutlinedIcon fontSize="small" />,
        bg: "#E3F2FD",
        color: "#1565C0",
      };
    case "product":
      return {
        icon: <WarningAmberOutlinedIcon fontSize="small" />,
        bg: "#FFF4E5",
        color: "#ED6C02",
      };
    default:
      return {
        icon: <Inventory2OutlinedIcon fontSize="small" />,
        bg: "#F3F4F6",
        color: "#555",
      };
  }
};

const formatDate = (date: string) => {
  return new Date(date).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const ActivityLogs = () => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    axios
      .get("https://store.petplanet.rw/api/activity-logs")
      .then((res) => setLogs(res.data));
  }, []);

  return (
    <Box
      p="20px"
      bgcolor="#fff"
      borderRadius="14px"
      border="1px solid #E5E7EB"
    >
      {/* Header */}
      <Typography
        variant="h3"
        fontSize="18px"
        fontWeight="500"
        mb="15px"
      >
        Recent Activity
      </Typography>

      {/* Logs */}
      {logs.map((log: any, index) => {
        const { icon, bg, color } = getIcon(log.module);

        return (
          <Box
            key={log.id}
            py="12px"
            borderBottom={index !== logs.length - 1 ? "1.5px solid #F1F1F1" : "none"}
          >
            {/* Top Row */}
            <Box display="flex" alignItems="center" gap="10px">
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: "8px",
                  backgroundColor: bg,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: color,
                }}
              >
                {icon}
              </Box>

              <Typography fontSize="14px" fontWeight="600">
                {`${log.action} ${log.module}`}
              </Typography>
            </Box>

            {/* Description */}
            <Typography
              fontSize="13px"
              fontWeight="500"
              mt="10px"
            >
              {log.description}
            </Typography>

            {/* Bottom Row */}
            <Box
              display="flex"
              justifyContent="space-between"
              mt="6px"
            >
              <Typography fontSize="12px" color="#888">
                {log.user || "System"}
              </Typography>

              <Typography fontSize="12px" color="#888">
                {formatDate(log.created_at)}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default ActivityLogs;